import { LmsProfileTypes } from 'enum/lms-profile-types.enum'
import api from '..'

interface UpdateLmsProfileParams {
  id: number
  name: string
  color: string
  profileType: LmsProfileTypes
}

const updateLmsProfile = (lmsProfile: UpdateLmsProfileParams) => {
  const id = lmsProfile.id
  return api.put(`administration/lms_profiles/${id}`, lmsProfile)
}

export default updateLmsProfile
